<h3 *ngIf="langue.l == 'fr'">Types de dégâts</h3>
<h3 *ngIf="langue.l == 'en'">Damage types</h3>

<p *ngIf="langue.l == 'fr'">
    Chaque attaque possède 2 catégories de types : son élément, et sa forme.<br/>
    <b>L'élément d'une attaque</b> est soit physique, soit un élément de magie pure, soit un élément de magie combinée.<br/>
    <b>La forme d'une attaque</b> est soit perçante, soit contondante, soit tranchante, soit brûlante, soit "autre"
    ("autre" est utilisé en général pour les poisons/debuffs).<br/>
    L'élément et la forme sont décidés quand l'attaque est effectuée.<br/>
    Pour <b>l'élément</b> :<br/>
    Si l'attaque vient d'une arme (ou d'un objet) non magique sans infusion, alors l'attaque est physique.
    Si l'attaque vient d'une arme infusée, alors son élément est physique.
    Si l'attaque vient d'un sort magique, alors l'élément est le même que celui de la magie manipulée.<br/>
    Pour <b>la forme</b> :<br/>
    La forme dépend de l'arme ou des détails de l'attaque magique.
    Si une arme a été utilisée (magique ou non, infusée ou non), alors l'attaque sera du même type que l'arme.
    Si une manipulation magique a été effectuée, alors l'élément particulier et la description de la manipulation mènent à la décision de la forme de l'attaque.<br/>
    <br/>
    Exemples :<br/>
    Un individu attaque avec une hache non magique non infusée. L'attaque sera physique tranchante.<br/>
    Un individu attaque avec un arc infusé d'air. L'attaque sera physique perçante.<br/>
    Un individu attaque avec un trait de feu. L'attaque sera feu brûlante.<br/>
    Un individu attaque avec un pic de glace. L'attaque sera glace perçante.<br/>
    Un individu attaque avec un tentacule. L'attaque sera tentacule contondant.<br/>
    <br/>
    La blessure résultante d'une attaque est de mêmes types que l'attaque.
    De manière générale, l'élément est important quand l'attaque est appliquée (donc pour l'attaquant),
    et la forme est plus importante durant le soin et le temps avant le soin (donc pour la victime).<br/>
    <br/>
    Certaines créatures peuvent avoir des résistances ou vulnérabilités à certains éléments,
    et il faut donc prendre en compte les éléments des attaques les ciblant pour calculer correctement les dégâts infligés :
    si une créature est <b>vulnérable</b>, alors les dégâts augmentent de 3 (avant le filtre de défense) ;
    si une créature est <b>résistante</b>, alors les dégâts sont diminués de 3 (min 0) ;
    si une créature est <b>invulnérable</b>, alors elle ne prend aucun dégâts.<br/>

</p>
<p *ngIf="langue.l == 'en'">
    <br/>
</p>


<h3 *ngIf="langue.l == 'fr'">Calcul des dégâts</h3>
<h3 *ngIf="langue.l == 'en'">Damage points</h3>

<p *ngIf="langue.l == 'fr'">
    Attaquant : <b>1dx</b> (selon arme) <b>+ stat</b> (force ou dex)<br/>
    Défense : <b>res + armure</b> (fixe)<br/>
    Dégâts de l'attaque - défense = dégâts en points de douleur (min 0, si 0 alors pas de blessure)<br/>
    <br/>
    Blessure infligée dépend du type de dégâts de l'arme :<br/>
    Tranchant = coupure<br/>
    Contondant = casse<br/>
    Perçant = perforation<br/>
    <br/>
    Les coupures causent un saignement, qui provoque une perte de sang, qui à son tour peut entraîner la mort de la victime.<br/>
    Les casses peuvent empêcher la victime d'agir (cf <a routerLink="/system/states" routerLinkActive="activebutton">état blessé</a>).<br/>
    <br/>
    Dégâts -1 = intensité de la blessure infligée (coupure ou casse)<br/>
    L'échelle des intensités commence à 0.<br/>
    0 : égratinure - ecchymose (bleu)<br/>
    1-2 : petite coupure - gros hématome<br/>
    3-4 : coupure moyenne - os fêlé<br/>
    5-6 : grosse coupure - os cassé<br/>
    7-8 : très grosse coupure - fracture ouverte<br/>
    9-10 : membre coupé - os pulvérisé<br/>
</p>
<p *ngIf="langue.l == 'en'">
    Attacker : <b>1dx</b> (depending on the weapon) <b>+ stat</b> (str or dex)<br/>
    Defense : <b>res + armor</b> (fixed)<br/>
    Attack damage - defense score = damage in pain points (min 0, if 0 then no wounds)<br/>
    <br/>
    Wound depends on the weapon damage type :<br/>
    Slashing / piercing = cut<br/>
    Bludgeoning = break<br/>
    <br/>
    Cuts cause bleeding, which can result in blood loss and in time, death.<br/>
    Breaks can prevent the victim from acting (see <a routerLink="/system/states" routerLinkActive="activebutton">wounded state</a>).<br/>
    <br/>
    Damage -1 = wound intensity (cut or break)<br/>
    The scale of the intensities start at 0.<br/>
    0 : scratch - bruise<br/>
    1-2 : small cut - big bruise<br/>
    3-4 : medium cut - fractured bone<br/>
    5-6 : big cut - broken bone<br/>
    7-8 : very big cut - very broken bone<br/>
    9-10 : limb cut off - all bones broken in the limb<br/>
</p>

<div class="div-table" *ngIf="langue.l == 'fr'">
  <table>
      <tr>
          <th>Profondeur / Saignement ?</th>
          <td>Saignante</td>
          <td>Gênante</td>
      </tr>
      <tr>
          <td>Surface</td>
          <td>Coupure</td>
          <td>Brûlure</td>
      </tr>
      <tr>
          <td>Profond</td>
          <td>Perforation</td>
          <td>Cassure</td>
      </tr>
  </table>
</div>
<div class="div-table" *ngIf="langue.l == 'en'">
  <table>
      <tr>
          <th>/</th>
      </tr>
  </table>
</div>


<h3 *ngIf="langue.l == 'fr'">Les conséquences d'une attaque</h3>
<h3 *ngIf="langue.l == 'en'">The consequences of an attack</h3>

<p *ngIf="langue.l == 'fr'">
    Après une attaque réussie, la victime subit une blessure. Cette blessure possède plusieurs caractéristiques :
    une forme, un élément, une taille, et une intensité.<br>
    L'élément est peu important une fois la blessure infligée.<br>
    La taille (en général 2 pour une arme, et selon la manipulation pour la magie) va donner un minimum de taille pour le soin.<br>
    La forme et l'intensité ont des effets avant le soin :
    si la blessure est saignante, alors la victime saigne et perd son sang à une vitesse déterminée par l'intensité de la blessure
    (cf <a routerLink="/character/dying" routerLinkActive="activebutton">mourir</a>) ;
    si la blessure est gênante, alors la victime peut perdre des PA selon un jet de résistance
    (cf <a routerLink="/system/states" routerLinkActive="activebutton">état blessé</a>).<br>
    La profondeur d'une blessure n'importe que pour le soin.
</p>
<p *ngIf="langue.l == 'en'">
    <br/>
</p>


<h3 *ngIf="langue.l == 'fr'">Accumulations (stacks) élémentaires</h3>
<h3 *ngIf="langue.l == 'en'">Elemental stacks</h3>

<p *ngIf="langue.l == 'fr'">
    Ceci est une suggestion de règle. Elle n'est pas encore officielle ni implémentée.<br>
    <br>
    Chaque attaque infligeant des dégâts inflige en plus un <b>point élémentaire</b> sur la cible de l'attaque
    (= la victime qui reçoit la blessure reçoit aussi le point élémentaire).
    Le point élémentaire est indépendant de la blessure et n'a aucun effet en lui même,
    mais peut se cumuler et <b>quand ils atteignent un seuil, ils explosent</b> et infligent un effet à la victime (puis reviennent à 0).<br>
    Les points élémentaires n'existent que pour les <b>éléments purs</b>.
    Les attaques avec des éléments combinés infligent un point dans chacune des magies pures liées.
    Les attaques physiques sans élément n'infligent aucun point élémentaire.
    Les points se cumulent indépendamment sur chaque élément, <b>sauf les éléments opposés qui s'annulent</b> (avec un ratio 1-1).
    L'effet résultant de l'explosion des stacks varie selon l'élément, et si 2 éléments sont proc-és en même temps,
    alors l'effet vient de leur magie combinée et remplace les effets venant des magies pures.<br>
    Le seuil en général est de 3. Il peut varier selon la taille, la sensitivité, et l'importance de la créature
    (par exemple si la créature est petite, le seuil peut baisser donc 2, et si la créature est grande le seuil peut monter à 4).<br>
    Si l'effet possède une durée, alors l'état infligé dure 2 tours globaux, et si le même état est infligé une nouvelle fois avant la fin du premier,
    alors l'état est accentué et la duration de 2 tours est rafraîchie (et non cumulée).<br>
    <br>
    Des exemples d'effets selon la magie (à déterminer ensemble et à équilibrer) :<br>
    <br>
    feu : dégâts de brûlure continus - plus de dégâts si mouvement<br>
    air : ralenti - perd balance<br>
    lumière : brille - malus aux attaques<br>
    nature : épines - entangled<br>
    eau : glissé / poussé - alourdi<br>
    ténèbre : aveuglé - anti magie<br>
    <br>
    explosion : encore plus d'explosion - lâcher ce qu'il tenait<br>
    tonnerre : incapacité à utiliser des objets - perdre des PA<br>
    croissance : alourdi - perd balance<br>
    purification : douleur en fonction des blessures (halp j'ai pas d'idées)<br>
    animaux : attaqué par des animaux (variés)<br>
    tentacules : grappled - slapped/dazed<br>
    glace : ralenti - gelé<br>
    esprit : perdre des PA - dazed<br>
    firewater : spawn du firewater sur/autour<br>
    terre : ralenti - alourdi<br>
    illusion : vision perturbée - hallucinations<br>
    âme : douleur - fatigue<br>
</p>
<p *ngIf="langue.l == 'en'">
    <br/>
</p>
